import { API_URL, MOKA_SERVICE_HOST } from '../constants';

const MOKA_BUSINESS_SERVICE = `${MOKA_SERVICE_HOST}/business-service`;

export const UPDATE_BUSINESS_REVENUE = (id) =>
  `${API_URL}/v1/businesses/${id}/revenue`;
export const UPDATE_BUSINESS_START_YEAR = (id) =>
  `${API_URL}/v1/businesses/${id}/start_year`;

export const UPDATE_BUSINESS = `${MOKA_BUSINESS_SERVICE}/v3/businesses`;
